<div #scrollArea class="line-view-scroll-area">
    <div class="line-view-container" (click)="onContainerClick($event)">
        @if (hasVehiclesWithFailedActivities()) {
            <p class="line-view-placement-warning" role="alert" translate>
                The grayed out vehicles have no activities or we failed to fetch
                them, because of that they can be shown on the wrong line and
                with the wrong direction.
            </p>
        }
        <div class="line-view-track">
            @for (
                stop of stops();
                track stop.index;
                let i = $index;
                let last = $last
            ) {
                <!-- Stop row -->
                <div class="stop-row">
                    <div class="cell-left">
                        @for (
                            v of getVehiclesAtPosition(i, 'left');
                            track v.inventoryNumber;
                            let vi = $index
                        ) {
                            <div
                                class="vehicle-connector"
                                [class.vehicle-dimmed]="isVehicleDimmed(v)"
                                [class.vehicle-failed]="v.activitiesFailed"
                            >
                                <div class="vehicle-marker-wrapper">
                                    <button
                                        class="vehicle-marker"
                                        [attr.aria-label]="
                                            'Vehicle ' +
                                            v.inventoryNumberWithoutPrefix
                                        "
                                        (mouseenter)="
                                            onVehicleMouseEnter($event, v)
                                        "
                                        (mouseleave)="onVehicleMouseLeave()"
                                        (click)="onVehicleClick(v)"
                                    >
                                        <svg
                                            class="vehicle-pin"
                                            viewBox="0 0 39 38"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                        >
                                            <path
                                                d="M19.1904 0C29.7888 7.22541e-05 38.3807 7.43569 38.3809 16.6074C38.3809 21.9093 35.509 26.6303 31.0391 29.6709L23.6094 36.041C21.0824 38.207 17.0126 38.1942 14.5264 36.0117L7.33496 29.6982C7.28782 29.6569 7.2426 29.6136 7.19727 29.5713C2.81001 26.5278 0 21.852 0 16.6074C0.000139251 7.43564 8.59202 0 19.1904 0Z"
                                                [attr.fill]="v.color"
                                                [attr.stroke]="v.variantColor"
                                                stroke-width="2"
                                            />
                                            <text
                                                x="19.19"
                                                y="17"
                                                text-anchor="middle"
                                                dominant-baseline="central"
                                                class="vehicle-pin-text"
                                            >
                                                {{
                                                    v.inventoryNumberWithoutPrefix
                                                }}
                                            </text>
                                        </svg>
                                        @if (v.hasWarning) {
                                            <i
                                                class="fas fa-exclamation-triangle vehicle-warning"
                                                aria-hidden="true"
                                            ></i>
                                        }
                                    </button>
                                </div>
                                <span
                                    class="connector-line"
                                    [style.background-color]="v.variantColor"
                                    [style.min-width.px]="
                                        getConnectorMinWidth(
                                            vi,
                                            i,
                                            'left',
                                            false
                                        )
                                    "
                                ></span>
                                <span
                                    class="connector-dot"
                                    [style.background-color]="v.variantColor"
                                    [style.margin-right.px]="
                                        getDotMargin(v.variantIndex, 'left')
                                    "
                                ></span>
                            </div>
                        }
                    </div>
                    <div class="cell-track">
                        @for (
                            variant of variants();
                            track $index;
                            let vi = $index
                        ) {
                            @if (
                                variant.fromStopIndex <= i &&
                                variant.toStopIndex >= i
                            ) {
                                <div
                                    class="track-line-variant-wrapper"
                                    [style.left.px]="getVariantHitOffset(vi)"
                                    [style.top]="
                                        i === variant.fromStopIndex
                                            ? '50%'
                                            : '-0.5px'
                                    "
                                    [style.bottom]="
                                        i === variant.toStopIndex
                                            ? '50%'
                                            : '-0.5px'
                                    "
                                    (mouseenter)="hoveredVariantIndex = vi"
                                    (mouseleave)="hoveredVariantIndex = null"
                                    (click)="onVariantClick(vi)"
                                >
                                    <div
                                        class="track-line-variant"
                                        [style.background-color]="variant.color"
                                        [class.variant-highlighted]="
                                            isVariantHighlighted(vi)
                                        "
                                        [class.variant-dimmed]="
                                            isVariantDimmed(vi)
                                        "
                                    ></div>
                                </div>
                            }
                        }
                        <div
                            class="stop-chip"
                            [class.stop-dimmed]="isStopDimmed(i)"
                            [style.min-width.px]="stopChipMinWidth()"
                            (mouseenter)="hoveredStopIndex = i"
                            (mouseleave)="hoveredStopIndex = null"
                        >
                            <span class="stop-name">{{ stop.name }}</span>
                        </div>
                    </div>
                    <div class="cell-right">
                        @for (
                            v of getVehiclesAtPosition(i, 'right');
                            track v.inventoryNumber;
                            let vi = $index
                        ) {
                            <div
                                class="vehicle-connector vehicle-connector-right"
                                [class.vehicle-dimmed]="isVehicleDimmed(v)"
                                [class.vehicle-failed]="v.activitiesFailed"
                            >
                                <span
                                    class="connector-dot"
                                    [style.background-color]="v.variantColor"
                                    [style.margin-left.px]="
                                        getDotMargin(v.variantIndex, 'right')
                                    "
                                ></span>
                                <span
                                    class="connector-line"
                                    [style.background-color]="v.variantColor"
                                    [style.min-width.px]="
                                        getConnectorMinWidth(
                                            vi,
                                            i,
                                            'right',
                                            false
                                        )
                                    "
                                ></span>
                                <div class="vehicle-marker-wrapper">
                                    <button
                                        class="vehicle-marker"
                                        [attr.aria-label]="
                                            'Vehicle ' +
                                            v.inventoryNumberWithoutPrefix
                                        "
                                        (mouseenter)="
                                            onVehicleMouseEnter($event, v)
                                        "
                                        (mouseleave)="onVehicleMouseLeave()"
                                        (click)="onVehicleClick(v)"
                                    >
                                        <svg
                                            class="vehicle-pin"
                                            viewBox="0 0 39 38"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                        >
                                            <path
                                                d="M19.1904 0C29.7888 7.22541e-05 38.3807 7.43569 38.3809 16.6074C38.3809 21.9093 35.509 26.6303 31.0391 29.6709L23.6094 36.041C21.0824 38.207 17.0126 38.1942 14.5264 36.0117L7.33496 29.6982C7.28782 29.6569 7.2426 29.6136 7.19727 29.5713C2.81001 26.5278 0 21.852 0 16.6074C0.000139251 7.43564 8.59202 0 19.1904 0Z"
                                                [attr.fill]="v.color"
                                                [attr.stroke]="v.variantColor"
                                                stroke-width="2"
                                            />
                                            <text
                                                x="19.19"
                                                y="17"
                                                text-anchor="middle"
                                                dominant-baseline="central"
                                                class="vehicle-pin-text"
                                            >
                                                {{
                                                    v.inventoryNumberWithoutPrefix
                                                }}
                                            </text>
                                        </svg>
                                        @if (v.hasWarning) {
                                            <i
                                                class="fas fa-exclamation-triangle vehicle-warning"
                                                aria-hidden="true"
                                            ></i>
                                        }
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>

                <!-- Segment between stops -->
                @if (!last) {
                    <div
                        class="segment-row"
                        [class.segment-short]="
                            variableSpacingEnabled &&
                            stops()[i].spacingClass === 'short'
                        "
                        [class.segment-medium]="
                            variableSpacingEnabled &&
                            stops()[i].spacingClass === 'medium'
                        "
                        [class.segment-large]="
                            variableSpacingEnabled &&
                            stops()[i].spacingClass === 'large'
                        "
                        [class.segment-extra-large]="
                            variableSpacingEnabled &&
                            stops()[i].spacingClass === 'extra-large'
                        "
                    >
                        <div class="cell-left">
                            @for (
                                v of getVehiclesBetween(i, 'left');
                                track v.inventoryNumber;
                                let vi = $index
                            ) {
                                <div
                                    class="vehicle-connector"
                                    [class.vehicle-dimmed]="isVehicleDimmed(v)"
                                    [class.vehicle-failed]="v.activitiesFailed"
                                    [style.transform]="
                                        continuousMotionEnabled
                                            ? getSegmentTranslateY(v, i)
                                            : null
                                    "
                                >
                                    <div class="vehicle-marker-wrapper">
                                        <button
                                            class="vehicle-marker vehicle-marker-small"
                                            [attr.aria-label]="
                                                'Vehicle ' +
                                                v.inventoryNumberWithoutPrefix
                                            "
                                            (mouseenter)="
                                                onVehicleMouseEnter($event, v)
                                            "
                                            (mouseleave)="onVehicleMouseLeave()"
                                            (click)="onVehicleClick(v)"
                                        >
                                            <svg
                                                class="vehicle-pin"
                                                viewBox="0 0 39 38"
                                                xmlns="http://www.w3.org/2000/svg"
                                                aria-hidden="true"
                                            >
                                                <path
                                                    d="M19.1904 0C29.7888 7.22541e-05 38.3807 7.43569 38.3809 16.6074C38.3809 21.9093 35.509 26.6303 31.0391 29.6709L23.6094 36.041C21.0824 38.207 17.0126 38.1942 14.5264 36.0117L7.33496 29.6982C7.28782 29.6569 7.2426 29.6136 7.19727 29.5713C2.81001 26.5278 0 21.852 0 16.6074C0.000139251 7.43564 8.59202 0 19.1904 0Z"
                                                    [attr.fill]="v.color"
                                                    [attr.stroke]="
                                                        v.variantColor
                                                    "
                                                    stroke-width="2"
                                                />
                                                <text
                                                    x="19.19"
                                                    y="17"
                                                    text-anchor="middle"
                                                    dominant-baseline="central"
                                                    class="vehicle-pin-text"
                                                >
                                                    {{
                                                        v.inventoryNumberWithoutPrefix
                                                    }}
                                                </text>
                                            </svg>
                                            @if (v.hasWarning) {
                                                <i
                                                    class="fas fa-exclamation-triangle vehicle-warning"
                                                    aria-hidden="true"
                                                ></i>
                                            }
                                        </button>
                                    </div>
                                    <span
                                        class="connector-line"
                                        [style.background-color]="
                                            v.variantColor
                                        "
                                        [style.min-width.px]="
                                            getConnectorMinWidth(
                                                vi,
                                                i,
                                                'left',
                                                true
                                            )
                                        "
                                    ></span>
                                    <span
                                        class="connector-dot"
                                        [style.background-color]="
                                            v.variantColor
                                        "
                                        [style.margin-right.px]="
                                            getDotMargin(v.variantIndex, 'left')
                                        "
                                    ></span>
                                </div>
                            }
                        </div>
                        <div class="cell-track">
                            @for (
                                variant of variants();
                                track $index;
                                let vi = $index
                            ) {
                                @if (
                                    variant.fromStopIndex <= i &&
                                    variant.toStopIndex > i
                                ) {
                                    <div
                                        class="track-line-variant-wrapper"
                                        [style.left.px]="
                                            getVariantHitOffset(vi)
                                        "
                                        (mouseenter)="hoveredVariantIndex = vi"
                                        (mouseleave)="
                                            hoveredVariantIndex = null
                                        "
                                        (click)="onVariantClick(vi)"
                                    >
                                        <div
                                            class="track-line-variant"
                                            [style.background-color]="
                                                variant.color
                                            "
                                            [class.variant-highlighted]="
                                                isVariantHighlighted(vi)
                                            "
                                            [class.variant-dimmed]="
                                                isVariantDimmed(vi)
                                            "
                                        ></div>
                                    </div>
                                }
                            }
                        </div>
                        <div class="cell-right">
                            @for (
                                v of getVehiclesBetween(i, 'right');
                                track v.inventoryNumber;
                                let vi = $index
                            ) {
                                <div
                                    class="vehicle-connector vehicle-connector-right"
                                    [class.vehicle-dimmed]="isVehicleDimmed(v)"
                                    [class.vehicle-failed]="v.activitiesFailed"
                                    [style.transform]="
                                        continuousMotionEnabled
                                            ? getSegmentTranslateY(v, i)
                                            : null
                                    "
                                >
                                    <span
                                        class="connector-dot"
                                        [style.background-color]="
                                            v.variantColor
                                        "
                                        [style.margin-left.px]="
                                            getDotMargin(
                                                v.variantIndex,
                                                'right'
                                            )
                                        "
                                    ></span>
                                    <span
                                        class="connector-line"
                                        [style.background-color]="
                                            v.variantColor
                                        "
                                        [style.min-width.px]="
                                            getConnectorMinWidth(
                                                vi,
                                                i,
                                                'right',
                                                true
                                            )
                                        "
                                    ></span>
                                    <div class="vehicle-marker-wrapper">
                                        <button
                                            class="vehicle-marker vehicle-marker-small"
                                            [attr.title]="
                                                v.inventoryNumberWithoutPrefix
                                            "
                                            [attr.aria-label]="
                                                'Vehicle ' +
                                                v.inventoryNumberWithoutPrefix
                                            "
                                            (mouseenter)="
                                                onVehicleMouseEnter($event, v)
                                            "
                                            (mouseleave)="onVehicleMouseLeave()"
                                            (click)="onVehicleClick(v)"
                                        >
                                            <svg
                                                class="vehicle-pin"
                                                viewBox="0 0 39 38"
                                                xmlns="http://www.w3.org/2000/svg"
                                                aria-hidden="true"
                                            >
                                                <path
                                                    d="M19.1904 0C29.7888 7.22541e-05 38.3807 7.43569 38.3809 16.6074C38.3809 21.9093 35.509 26.6303 31.0391 29.6709L23.6094 36.041C21.0824 38.207 17.0126 38.1942 14.5264 36.0117L7.33496 29.6982C7.28782 29.6569 7.2426 29.6136 7.19727 29.5713C2.81001 26.5278 0 21.852 0 16.6074C0.000139251 7.43564 8.59202 0 19.1904 0Z"
                                                    [attr.fill]="v.color"
                                                    [attr.stroke]="
                                                        v.variantColor
                                                    "
                                                    stroke-width="2"
                                                />
                                                <text
                                                    x="19.19"
                                                    y="17"
                                                    text-anchor="middle"
                                                    dominant-baseline="central"
                                                    class="vehicle-pin-text"
                                                >
                                                    {{
                                                        v.inventoryNumberWithoutPrefix
                                                    }}
                                                </text>
                                            </svg>
                                            @if (v.hasWarning) {
                                                <i
                                                    class="fas fa-exclamation-triangle vehicle-warning"
                                                    aria-hidden="true"
                                                ></i>
                                            }
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
            }
        </div>
    </div>
</div>
<app-line-view-minimap
    [stops]="stops()"
    [vehicles]="vehicles()"
    [variants]="variants()"
    [scrollContainer]="scrollArea"
    [hoveredVariantIndex]="hoveredVariantIndex"
    [selectedVariantIndex]="selectedVariantIndex"
    [hoveredStopIndex]="hoveredStopIndex"
></app-line-view-minimap>
